/**
 * SMB Component - Comparison table
 * @copyright 2018 AVAST Software s.r.o.
 * @author Erik Ondrus
 * @version 1.0
 * @since 2018-03
 *
 * DESCRIPTION:
 * Basic functionality of comparison table
 *
 * CAUTION!
 * 'data-platform' attribute is used by /smb/components/faq-and-system-requirements.js
 */

"use strict";

$(document).ready(function () {

    //jQuery Elements
    var $comparisonTable = $('#comparison-table'),
        $stickyPanel = $('.c-comparison-sticky'),
        $platformButton = $('.js-ct-platform'),
        $feature = $('.c-comparison-table__feature'),

        $showMore = $('.js-show-more'),
        $showLess = $('.js-show-less');


    //Variables
    var activeClass = 'c-comparison-nav__platform_active',
        activePlatform = $('.'+activeClass).data('platform'),
        stickyPanelTimeout;


    /**
    * The method will show and hide the sticky panel
    */
    var showStickyPanel = function() {

        const subtractBottomPart = 350; //The value that hides the panel before the table ends
        var cTHeight = $comparisonTable.outerHeight()
        var cTPostion = $comparisonTable.offset().top;
        var cTPostionBottom = (cTPostion + cTHeight) - subtractBottomPart;
        var scrollY = document.documentElement.scrollTop;

        if ((scrollY >= cTPostion) && (scrollY < cTPostionBottom) && (cTHeight >= 800)) {

            stickyPanelTimeout = setTimeout(function () {        //Wait when scrolling fast
                cTPostion = $comparisonTable.offset().top;
                cTPostionBottom = (cTPostion + $comparisonTable.outerHeight()) - subtractBottomPart;
                scrollY = document.documentElement.scrollTop;

                if ((scrollY >= cTPostion) && (scrollY < cTPostionBottom)) {
                    $stickyPanel.slideDown(300);
                }
            }, 800);

        }
        else {
            clearTimeout(stickyPanelTimeout);
            $stickyPanel.slideUp(100);
        }
    }


    /**
    * The method will set active class on platform
    */
    var setActiveClassPlatform = function(that) {
        $platformButton.removeClass(activeClass);
        activePlatform = that.data('platform');
        localStorage.setItem("activePlatform", activePlatform);
        $('.c-comparison-nav [data-platform='+activePlatform+']').addClass(activeClass);
        $('.c-comparison-sticky [data-platform='+activePlatform+']').addClass(activeClass);
    }

    /**
    * The method will show best value product for MAC
    */
    var markBestValueProduct = function(that) {
        $('.c1, .c2, .c3').removeClass('inactive');
        $('.c-comparison-table__best b').addClass('hidden');
        $('.c-comparison-table__best .c-tooltip').hide();
        
        if (activePlatform == 'mac') {        
            $('.js-best-for-mac').removeClass('hidden');  
            $('.c-comparison-table__best .c-tooltip.js-best-for-mac').show();        
            $('.c2, .c3').addClass('inactive');
        }
        else if (activePlatform == 'winserver') {              
            $('.c-comparison-table__best b:not(.js-best-for-mac)').removeClass('hidden');                       
            $('.c-comparison-table__best .c-tooltip.js-winserver').show();
            $('.c3').addClass('inactive');
        }
        else {
            $('.c-comparison-table__best b:not(.js-best-for-mac)').removeClass('hidden');                    
            $('.c-comparison-table__best .c-tooltip.js-win').show();
        }
    }

    /**
    * The method will show correct features
    */
    var showFeatures = function() {
        const maxNumberOfFeatures = 13;

        $showMore.hide();
        $showLess.hide();

        $feature.hide();
        $('.js-feature-'+activePlatform).show();

        if (($showMore.length) && ($('.js-feature-'+activePlatform).length > maxNumberOfFeatures)) {
            $showMore.show();
            $feature.not('.js-feature-main').hide();
        }

        if (($showMore.is(':visible')) && (localStorage.getItem('showedMore') === 'true')) {
            $showMore.click();
        }
    }



    /**
    * Handlers
    */
    showFeatures();

    showStickyPanel();
    $(window).on('scroll', function () {
        showStickyPanel();
    });

    $platformButton.on('click', function () {
        setActiveClassPlatform($(this));
        markBestValueProduct();
        showFeatures();
        showStickyPanel();
    });


    $showMore.on('click', function () {
        $('.js-feature-'+activePlatform).show();
        $showMore.hide();
        $showLess.show();
        localStorage.setItem('showedMore', 'true');
    });
    $showLess.on('click', function () {
        $feature.not('.js-feature-main').hide();
        $showLess.hide();
        $showMore.show();
        localStorage.removeItem('showedMore');
    });

    // Local storage
    /*if (typeof(Storage) !== 'undefined') {
        if (localStorage.getItem('activePlatform') !== null) {
            var storagePlatform = localStorage.getItem('activePlatform');
            $('[data-platform='+storagePlatform+']').click();
        }
        if (($showMore.is(':visible')) && (localStorage.getItem('showedMore') === 'true')) {
            $showMore.click();
        }
    }*/

});
